import { graphql, useFragment } from 'react-relay';

import { TaskSecondLabelingDifferenceCounterLabel_difference$key } from '../../../relay/__generated__/TaskSecondLabelingDifferenceCounterLabel_difference.graphql';
import { isNullable } from '../../../utils/is';
import CounterLabel, { CounterLabelProps } from '../../core/CounterLabel';

const TaskSecondLabelingDifferenceCounterLabel_difference = graphql`
  fragment TaskSecondLabelingDifferenceCounterLabel_difference on Difference {
    ... on TaskSecondLabelingDifference {
      difficulty {
        __typename
      }
      unitDs {
        __typename
      }
      problem {
        __typename
      }
      solution {
        __typename
      }
      answer {
        __typename
      }
      answerChoiceCount {
        __typename
      }
      answerType {
        __typename
      }
    }
  }
`;

type Props = { difference: TaskSecondLabelingDifferenceCounterLabel_difference$key } & CounterLabelProps;

const TaskSecondLabelingDifferenceCounterLabel = ({ difference, ...props }: Props) => {
  const { difficulty, unitDs, answer, answerChoiceCount, answerType, problem, solution } = useFragment(
    TaskSecondLabelingDifferenceCounterLabel_difference,
    difference,
  );

  const differenceCount = [difficulty, unitDs, answer, answerChoiceCount, answerType, problem, solution].filter(
    (diff) => !isNullable(diff),
  ).length;
  return <CounterLabel {...props}>{differenceCount}</CounterLabel>;
};

export default TaskSecondLabelingDifferenceCounterLabel;
